/**
 * Maps the result of "send the demo itinerary" (admin WhatsApp conversations
 * page) to a translation key and whether it counts as success.
 *
 * The backend returns demo.start_demo's outcome unchanged -- 'sent',
 * 'already_sent', 'no_activities', ... -- so the admin sees what actually
 * happened. Each one means something different to DO: 'already_sent' is
 * fine (the prospect has it), 'no_activities' means the demo day is empty
 * and needs fixing in the ride, not a retry.
 *
 * Plain function with no Vue dependency so tests/unit can cover it.
 */

const OUTCOME_KEYS = {
  sent: 'waDemoSendSent',
  already_sent: 'waDemoSendAlreadySent',
  no_activities: 'waDemoSendNoActivities',
  no_date: 'waDemoSendNoDate',
  opted_out: 'waDemoSendOptedOut',
  skipped_no_template: 'waDemoSendNoTemplate',
};

const SUCCESS = new Set(['sent', 'already_sent']);

// `outcome` from a 200 response, or `errorCode` from a refused one
// (error.response.data.error). Anything unrecognised falls back to the
// generic failure key; the raw outcome is shown beside it by the page.
function demoSendResult( outcome, errorCode ) {
  if ( errorCode === 'not_demo' ) {
    return { key: 'waDemoSendNotDemo', ok: false };
  }
  if ( outcome && OUTCOME_KEYS[outcome] ) {
    return { key: OUTCOME_KEYS[outcome], ok: SUCCESS.has( outcome ) };
  }
  return { key: 'waDemoSendFailed', ok: false };
}

// CommonJS, matching the other src/utils helpers: webpack consumes it from
// the component, and tests/unit can require it under plain node.
module.exports = { demoSendResult };
